<template>
<div>

  <div v-for="(tor, index) in torneio" v-if="tor.dif > 0 && tor.tipo_id != 4">

      <div class="col-md-12">
          <div class="card text_branco mb-3" v-bind:class="[tor.tipo_id==1?'card_lista_roxo':tor.tipo_id==2?'card_lista_verde':'card_lista_laranja']">
            <div class="row">

              <div class="col-md-4 text_13 text_bold pt-2" v-bind:class="[tor.tipo_id==1?'text_roxo':tor.tipo_id==2?'text_verde':'text_laranja']">
                  {{tor.nome}} | R$ {{formatarMoeda(tor.prize)}}
              </div>
              <div class="col-md-2 text_13 text_cinza text-center pt-2">
                  Odd: @{{formatarMoeda(tor.odd)}}
              </div>
              <div class="col-md-1 text_13 text_cinza text-center pt-2">
                  {{tor.qtd_aposta}}/{{tor.max_pessoa}}
              </div>
              <div class="col-md-2 text_13 text_amarelo text-center pt-2">
                  {{tor.time_regressivo}}
              </div>
              <div class="col-md-3 text_13 text_bold" v-bind:class="[tor.tipo_id==1?'text_roxo':tor.tipo_id==2?'text_verde':'text_laranja']">
                  <router-link :to="{name:'torneio_detalhes', params:{torneio_id:tor.id,page_back:0} }"
                  class="card text-center text_10 mt-1 w-100" v-bind:class="[tor.tipo_id==1?'btn_roxo':tor.tipo_id==2?'btn_verde':'btn_laranja']"> 
                  <b>VER JOGOS |
                    <span v-if="[1, 2].includes(tor.tipo_id)">R$ {{tor.taxa_entrada}}</span>
                    <span v-if="tor.tipo_id == 3">GRÁTIS</span>
                  </b>
                  </router-link>
              </div>

            </div>
          </div>
      </div>

  </div>


<!-- <div v-for="(tor, index) in torneio" v-if="tor.dif > 0">
    <div class="col-md-12">
        <div class="card text_branco mb-3" v-bind:class="[tor.tipo_id==1?'card_lista_roxo':tor.tipo_id==2?'card_lista_verde':'card_lista_laranja']">
          <div class="row">
            
            <div class="col-md-3 text_13 text_bold" v-bind:class="[tor.tipo_id==1?'text_roxo':tor.tipo_id==2?'text_verde':'text_laranja']">
                <router-link :to="{name:'torneio_detalhes', params:{torneio_id:tor.id,page_back:0} }"
                class="card text-center text_10 mt-1 w-100" v-bind:class="[tor.tipo_id==1?'btn_roxo':tor.tipo_id==2?'btn_verde':'btn_laranja']"
                > <b>VER DETALHES | GRÁTIS</b>
                </router-link>
            </div>

          </div>
        </div>
    </div>
</div> -->

</div>
</template>

<script>

import ccContagemRegressiva from '../cc_geral/cc_contagem_regressiva.vue'
import ccMensagem from '../cc_geral/mensagem.vue'
import ccAlert from '../cc_geral/cc_alert.vue'

export default {
  data () {
    return {
      //socket
      socket : {},
      canal : "canal_home",
      countSocket: 0,
      fala_servidor: null,
      fonte: null,

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors:[],

      //array
      original: [],
      torneio: [],      
    }
  },

  components: {ccContagemRegressiva, ccMensagem, ccAlert},

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    this.start_time()
  },

  methods: {

      receber_dados(response){
        this.original = response
        this.higienizar()
      },

      higienizar(){
        let agora = Date.now()
        let a = this.original
        var obj = {}
        this.torneio = []
        let dif = 0;

        for (var i=0; i <= a.length -1; i++) {
          if(a[i].qtd_aposta < a[i].max_pessoa) {
              dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
              dif = parseInt(dif/1000);

              if(dif > 0){
                obj = {
                  id :a[i].id,
                  nome :a[i].nome,
                  tipo_id :a[i].tipo_id,
                  sumario :a[i].sumario,
                  dt_inicio_timestamp :a[i].dt_inicio_timestamp,
                  descricao_pagamento :a[i].descricao_pagamento,
                  odd :a[i].odd,
                  taxa_entrada :a[i].taxa_entrada,
                  min_pessoa :a[i].min_pessoa,
                  max_pessoa :a[i].max_pessoa,
                  max_reentrada :a[i].max_reentrada,
                  qtd_aposta :a[i].qtd_aposta,
                  qtd_jogo :a[i].qtd_jogo,
                  qtd_mercado_obrigatorio :a[i].qtd_mercado_obrigatorio,
                  prize :a[i].prize,
                  status :a[i].status,
                  status_nome :a[i].status_nome,
                  destaque :a[i].destaque,
                  jogo: a[i].jogo,
                  dt_termino_timestamp: a[i].dt_termino_timestamp,
                  dif: dif,
                  time_regressivo: this.timestamp_horas_minutos_segundos(dif),
                  tag_id: a[i].tag_id,
                  tag_nome: a[i].tag_nome,
                }
              }

              this.torneio.push(obj);
          }
        }

        // console.log(this.torneio)

      },

      start_time(){
        this.timer_torneio_horario = setInterval( function(){

          for (var i=0; i < this.torneio.length; i++){
            this.torneio[i].dif = this.torneio[i].dif - 1;
            this.torneio[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio[i].dif )
          }

        }.bind(this), 1000);
      },

  },

}
</script>


// WEBPACK FOOTER //
// src/components/home_torneio/home_torneio_cc_lista.vue